import React, { useState } from 'react';
import {
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
  Typography
} from '@mui/material';
import { Box } from '@mui/system';
import { Icon } from '@iconify/react';
import { firestore } from '../../../../contexts/FirebaseContext';
import useAuthUsers from '../../../../hooks/useAuthUsers';
import { LoadingButton } from '@mui/lab';
import { useForm } from 'react-hook-form';
import { useSnackbar } from 'notistack';

export default function PaymentReportCancel({ dataItem }) {
  const [openDialog, setOpenDialog] = useState(false);

  return (
    <>
      {/* <Button variant="contained" color="info" onClick={() => setOpenDialog(true)}>
        Abrir dialogo
      </Button> */}
      <MenuItem onClick={() => setOpenDialog(true)}>Cancelar reporte de pago</MenuItem>
      <DialogBody open={openDialog} onClose={setOpenDialog} dataItem={dataItem} />
    </>
  );
}

function DialogBody({ open, onClose, dataItem }) {
  const { currentUser, verifyUserNip } = useAuthUsers();
  const { enqueueSnackbar } = useSnackbar();

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting }
  } = useForm();

  console.log(dataItem);

  const handleClose = () => {
    onClose(false);
  };

  const cancelarReporte = async (dataForm) => {
    if (verifyUserNip(dataForm.nip)) {
      await firestore
        .collection('payment_reports')
        .doc(dataItem.id)
        .update({
          cancelingUser: currentUser.id,
          status: 'CANCELADO',
          cancel_message: dataForm.message || 'Sin mensaje',
          cancel_at: new Date(),
          updated_at: new Date()
        });

      enqueueSnackbar('Reporte cancelado', { variant: 'success' });
    } else {
      enqueueSnackbar('Ingrese un codigo NIP valido', { variant: 'error' });
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <Typography textAlign="center" variant="subtitle1">
          Cancelar reporte de pago
        </Typography>
        <Card sx={{ padding: '15px', marginTop: '15px' }} component="form" onSubmit={handleSubmit(cancelarReporte)}>
          <Box marginBottom="15px">
            <TextField
              type="password"
              fullWidth
              {...register('nip', { required: true })}
              variant="outlined"
              label="NIP"
            />
            {errors.nip && (
              <Typography color="error" fontSize="13px">
                Ingrese su NIP
              </Typography>
            )}
          </Box>
          <Box marginBottom="15px">
            <TextField fullWidth {...register('message', { required: true })} variant="outlined" label="Mensaje" />
            {errors.message && (
              <Typography color="error" fontSize="13px">
                Ingrese un mensaje
              </Typography>
            )}
          </Box>
          <LoadingButton loading={isSubmitting} fullWidth variant="contained" type="submit">
            Cancelar reporte
          </LoadingButton>
        </Card>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit" startIcon={<Icon icon="eva:arrow-back-fill" />}>
          Atras
        </Button>
      </DialogActions>
    </Dialog>
  );
}
